// LOADING SCREEN *****************************************
$(window).on("load", function() {                
    $("#IndexLoadingScreen").addClass("hidden");
});












// HANDLE OPEN CART CASE *****************************************
$(window).on("load", function() {                                                                                                                   
    let params = new URLSearchParams(window.location.search);
    let openCartParam = params.get("opencart");
    if (openCartParam === "true") {
        setTimeout(function() {
            $("#NavCartButton").click(); 
        }, 500);
    } 
});












// FEATURED PRODUCT CAROUSEL ***************************************** 
$(window).on("load", function() {                                                  




    // init global ***
    var pcDone = true; 
    var pcCarTranslateValue;
    var pcCarMoveAmount;  
    var pcResizeTimer = null;




    // init car max index *** 
    $(".featured-product-carousel").each(function(i, obj) {
        let thisMaxIndex = $(obj).find(".dds-product").length;
        $(obj).attr("data-fpcactivecarnum", 1);
        $(obj).attr("data-fpcmaxcarnum", thisMaxIndex);  
    });




    // set carousel distance / width / height ***
    $(window).on("resize", function() { 
        clearTimeout(pcResizeTimer);
        pcResizeTimer = setTimeout(() => {

            // set translate value 
            let pcExtraTranslateVal = 30; 
            pcCarTranslateValue = $(".fpc-car-inner .dds-product").outerWidth() + pcExtraTranslateVal;

            // set move amount
            if (window.innerWidth >= 1031) { pcCarMoveAmount = 3; } 
            else if (window.innerWidth >= 661) { pcCarMoveAmount = 2; } 
            else { pcCarMoveAmount = 1; }

            // set carousel width + product height 
            $(".featured-product-carousel").each(function(i, obj) {
                let thisMaxIndex = Number($(obj).attr("data-fpcmaxcarnum"));    
                $(obj).find(".fpc-car-inner").css({"width": ((thisMaxIndex + 1) * pcCarTranslateValue) + "px"});
                let thisProducts = $(obj).find(".dds-product");
                thisProducts.css("height", "auto");
                let thisProductsMaxHeight = 0;
                thisProducts.each(function () {
                    thisProductsMaxHeight = Math.max(thisProductsMaxHeight, this.getBoundingClientRect().height);
                }); 
                thisProducts.css("height", thisProductsMaxHeight + "px");
            });

        }, 50);
    }).resize();




    // control carousel *** 
    $(".fpc-controls img").click(function() {
        if (pcDone) {

            // done util
            pcDoneUtil();

            // init 
            let thisCarParent = $(this).parent().parent();
            let thisCarContainer = thisCarParent.find(".fpc-car-outer");
            let thisActiveCarNum = Number(thisCarParent.attr("data-fpcactivecarnum"));
            let thisMaxCarNum = Number(thisCarParent.attr("data-fpcmaxcarnum"));
            let visibleSlots = Math.max(1, Math.floor(thisCarContainer.width() / pcCarTranslateValue));
            let maxStartIndex = Math.max(1, thisMaxCarNum - visibleSlots + 1);

            // left
            if ($(this).hasClass("fpc-controls-left") && thisActiveCarNum > 1) {
                thisActiveCarNum = Math.max(1, thisActiveCarNum - pcCarMoveAmount);
                thisCarParent.attr("data-fpcactivecarnum", thisActiveCarNum);
                transitionCarousel(thisCarParent, thisActiveCarNum);
            }

            // right
            if ($(this).hasClass("fpc-controls-right") && thisActiveCarNum < maxStartIndex) {
                thisActiveCarNum = Math.min(maxStartIndex, thisActiveCarNum + pcCarMoveAmount);
                thisCarParent.attr("data-fpcactivecarnum", thisActiveCarNum);
                transitionCarousel(thisCarParent, thisActiveCarNum);
            }

        }
    }); 




    // transition carousel function ***
    function transitionCarousel(car, activeNum) {
        car.find(".fpc-car-inner").css({"transform":"translate(" + ((pcCarTranslateValue * -1) * (activeNum - 1)) + "px,0px)"});  
    }




    // done util ***
    function pcDoneUtil() {
        pcDone = false;
        setTimeout(function() { pcDone = true; }, 400);
    }  




});












// SHOP BY BRAND CAROUSEL ***************************************** 
$(window).on("load", function() {                                                       




    // init global ***
    var sbbCarTranslateValue,
        sbbCurrentIndex = 1,
        sbbMaxIndex = 15,
        sbbAutoTimer,
        sbbPauseTimer;




    // start slider function ***
    function sbbStartAutoSlide() {
        sbbStopAutoSlide();
        sbbAutoTimer = setInterval(function () { sbbNextSlide(); }, 1500);
    }




    // stop slider function *** 
    function sbbStopAutoSlide() {
        clearInterval(sbbAutoTimer);
    }




    // pause slider function ***
    function sbbPauseAutoSlide(ms) {
        sbbStopAutoSlide();
        clearTimeout(sbbPauseTimer);
        sbbPauseTimer = setTimeout(sbbStartAutoSlide, ms);
    }




    // prev slide function *** 
    function sbbPrevSlide(isManual) {
        if (sbbCurrentIndex > 1) {
            sbbCurrentIndex--;
            sbbTransitionCarousel();
        }
        if (isManual) { sbbPauseAutoSlide(5000); }
    }




    // next slide function *** 
    function sbbNextSlide(isManual) {
        if ($("#SBBCarOuter").width() >= ((sbbMaxIndex - sbbCurrentIndex) * sbbCarTranslateValue)) {
            sbbCurrentIndex = 1;
        } else {
            sbbCurrentIndex++;
        }
        sbbTransitionCarousel();
        if (isManual) { sbbPauseAutoSlide(5000); }
    }




    // click handlers *** 
    $(".sbbcarcontrol.left").on("click", function () { sbbPrevSlide(true); });
    $(".sbbcarcontrol.right").on("click", function () { sbbNextSlide(true); });




    // transition *** 
    function sbbTransitionCarousel() {
        $("#SBBCarInner").css({ "transform": "translate(" + ((sbbCarTranslateValue * -1) * (sbbCurrentIndex - 1)) + "px,0px)" }); 
    }




    // pause on hover ***
    $("#SBBCarOuter").on("mouseenter", function () {
        sbbStopAutoSlide();
        clearTimeout(sbbPauseTimer); 
    }).on("mouseleave", function () {
        sbbStartAutoSlide();  
    });




    // set translate value *** 
    $(window).on("resize", function () {
        let sbbCarIndicator = $("#ShopByBrandSection #SBBHeader").css("width");
        if (sbbCarIndicator === "500px") { sbbCarTranslateValue = 200; }
        if (sbbCarIndicator === "330px") { sbbCarTranslateValue = 130; } 
    }).resize();




    // start *** 
    sbbStartAutoSlide(); 




});











